export * from './layer-item.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/layer/layer-item/index.ts